import { createClient } from '@supabase/supabase-js';

// Configuração do Supabase - usando variáveis de ambiente ou fallback
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ycuduaprtzxsleazqfbh.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InljdWR1YXBydHp4c2xlYXpxZmJoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0ODk0MDMsImV4cCI6MjA3NTA2NTQwM30.-hayGDrt47PiMZHYq7iKNFLPB5X5856B6i1J3PO8mcc';

// Lazy loading do cliente Supabase - só é criado quando necessário
let supabaseClient: ReturnType<typeof createClient> | null = null;

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(supabaseUrl, supabaseAnonKey);
  }
  return supabaseClient;
};

// Função para testar a conexão com o Supabase
export const testSupabaseConnection = async (): Promise<boolean> => {
  try {
    const supabase = getSupabaseClient();
    
    // Testa uma consulta simples para verificar se a conexão está funcionando
    const { error } = await supabase
      .from('clients')
      .select('id')
      .limit(1);
    
    if (error) {
      console.error('Erro na conexão com Supabase:', error);
      return false;
    }
    
    return true;
  } catch (err) {
    console.error('Erro ao testar conexão com Supabase:', err);
    return false;
  }
};

// Interface para o cliente no banco
export interface ClientDB {
  id?: string;
  nome: string;
  email: string;
  whatsapp?: string | null;
  descricao_projeto?: string | null;
  funcionalidades_projeto: {
    geracao_pecas: boolean;
    analise_documentos: boolean;
    exibicao_dashboard: boolean;
    integracoes: boolean;
  };
  primeira_call_realizada: boolean;
  data_primeira_call?: string | null;
  hora_primeira_call?: string | null;
  segunda_call_realizada: boolean;
  data_segunda_call?: string | null;
  hora_segunda_call?: string | null;
  transcricao_call?: string | null;
  proposta_implementacao?: string | null;
  tamanho_cliente?: string | null;
  tamanho_projeto?: string | null;
  proposta_gerada: boolean;
  cliente_fechado: boolean;
  closer_id?: string | null;
  status: 'sem-call' | 'aguardando-proposta' | 'proposta-feita' | 'fechado';
  created_at?: string;
  updated_at?: string;
}

// Interface para arquivos do cliente
export interface ClientFile {
  id: string;
  client_id: string;
  file_name: string;
  file_size: number;
  file_type: string;
  file_url: string;
  uploaded_by: string;
  uploaded_at: string;
}
